import React from 'react';
import { connect } from 'react-redux';
import { Spin, Tooltip, notification, Button } from 'antd';
import { delay, get } from 'lodash';
import PropTypes from 'prop-types';
import TestsActions from './Tests.actions';
import { isMobile as isMobileDevice } from "react-device-detect";
import {StartMCQModal} from './Modals/StartMCQ.modal';
import StartASAModal from './Modals/StartASA.modal';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import { convertTime } from '../../services/commonAPI';
import roundCheck from '../../../assets/img/round-check_circle-24px.svg';
import roundUncheck from '../../../assets/img/round-uncheck_circle-24px.svg';
import axios from 'axios';
import jwt from 'jsonwebtoken';
import { ApiConstant, PageConstant } from '../../../constants';
import { takeChallengeAction } from '../../reducers/dv2Actions';
import { withRouter } from 'react-router-dom';
import helpers from '../../helpers';
import TakeNextMCQModal from './Modals/TakeNextMCQ.modal';
import SkillsEditorModal from './Modals/ SkillsEditor.modal';
import { pushLog2DV2LogServer } from '../../../services/logging';
import TagManager from 'react-gtm-module';
import queryString from 'query-string';
import { MCQ_GROUPS, TestState } from './constants';
import TakeNextMCQV2 from './Modals/TakeNextMCQV2.modal';
import TechLeadModel from './Modals/TechLead.model';
import FailedMCQModal from './Modals/FailedMCQ.modal';
import TechLeadNextStack from './Modals/TechLeadNextStack.model';
import { CalendarIcon, CheckMarkIcon, ClockIcon, CrossIcon, PausedIcon } from '../../components/common/CustomIcon';
import { redirectAiToVettingEngine, redirectMCQToVettingEngine, redirectToVettingEngineV2 } from '../../../../services/util/redirectToVettingEngine';
import { GB_FLAGS, withLDFlagsFromBackend } from '../../services/launchDarkly';
import { changePreviousDevData } from '../../../components/Delights/util';
import { COMPARE_STATUS, STATUS } from '../../constants/status';
import getEnv from '../../../../services/util/getEnv';
import { turingLogger } from '../../../../shared/TuringLogger';
import ChallengePagePopup from '../home/HomeV1/mobile/ChallengePagePopup';

momentDurationFormatSetup(moment);
const isMobile = isMobileDevice || window.innerWidth < 1280;

function withTestsService(Component) {
  const token = localStorage.getItem('token');
  if (token) {
    axios.defaults.headers.common.Authorization = token;
  }
  /**
   * Tests services
   */
  class TestsService extends React.Component {
    state = {
      editSkillsVisible: false,
      refreshProgressBar: false,
      nextMCQ: null,
      activeIndex: 0,
      totalStackTest: 1,
      techLeadModalVisible: false,
      showFailedModal: { visible: false, item: null, test: null },
      isMobilePopupOpen: false
    };

    /**
    * This function dispatches the relevant event based on the flag value.
    * @param {*} mcq_use_apiv1 The flag value of mcq_use_apiv1 in Growthbook
    */
    loadMCQData = () => {
      this.props.dispatch(TestsActions.LOAD_MCQ_CHALLENGES_V2)
    };

    openMobilePopup = () => {
      this.setState({ isMobilePopupOpen: true })
    }

    closeMobilePopup = () => {
      this.setState({ isMobilePopupOpen: false })
    }

    loadWorkExpMCQ = () => {
      this.props.dispatch(TestsActions.FETCH_WORK_EXP_INFO);
    };

    checkProfileCompleteStatus = () => {
      this.props.dispatch(TestsActions.CHECK_PROFILE_STATUS);
    };

    setShowFailedModal(show = true, item = null, test = null) {
      this.setState({ ...this.state, showFailedModal: { visible: show, item, test } });
    }

    getSeniority = () => {
      this.props.dispatch({ type: TestsActions.GET_SENIORIY_LEVEL });
      setTimeout(() => {
        this.props.dispatch({ type: TestsActions.REMOVE_SENIORITY_LEVEL });
      }, 5000);
    }

    closeWorkExpModal = () => {
      this.props.dispatch({ type: TestsActions.CLOSE_WORK_EXP_MODAL });
    }

    loadTagsMCQFilter = () => {
      this.props.dispatch(TestsActions.LOAD_TAGS_MCQ_FILTER);
    }

    componentDidMount() {
      window.addEventListener('vetting-refresh', this.loadWorkExpMCQ);
      this.showNextMCQ();
    }

    componentWillUnmount() {
      window.removeEventListener('vetting-refresh', this.loadWorkExpMCQ);
    }

    getData = (name, defaultValue = null) => {
      const data = this.props.store && this.props.store.tests;
      switch (name) {
        case 'user_role_name': {
          const roles = get(data, 'roles', []);
          const role_type_id = get(data, 'personal_info.role_type_id', 0);
          const role = roles.find(r => r.role_id === role_type_id);
          if (role) return role.role_name;
          return defaultValue;
        }
        default: {
          const value = get(data, name, defaultValue);
          return value === null ? defaultValue : value;
        }
      }
    };

    updateUserRole = (roleId) => {
      this.props.dispatch(TestsActions.UPDATE_MCQ_ROLE(roleId));
    };

    checkTakeOneMCQ = () => {
      const recommendedMCQ = this.getData('recommendedMCQ', [])
        .filter(mcq => mcq.category_type === MCQ_GROUPS.TAKE_ONE);
      const TAKE_ONE_LIST = this.getData('challenges', []).map(this.initMCQItemAB).filter((mcq) => mcq.Tags.includes(MCQ_GROUPS.TAKE_ONE));
      return recommendedMCQ.every(elm =>
        TAKE_ONE_LIST
          // Please make a note that `category_names` has been removed from the new MCQ List API /api/v1/challenge/mcq/
          .filter(mcq => mcq.category_names.split(',').includes(elm.category_name))
          .some(mcq => mcq.isCompleted)
      );
    }

    getTakeOneCategoriesNames = () => {
      const recommendedMCQ = this.getData('recommendedMCQ', [])
        .filter(mcq => mcq.category_type === MCQ_GROUPS.TAKE_ONE)
        .map(mcq => mcq.category_name);
      const lastElm = recommendedMCQ.pop();
      const title = ['At least one'];
      if (recommendedMCQ.length) {
        title.push(recommendedMCQ.join(', '));
        title.push('and');
      }
      title.push(lastElm);
      title.push(recommendedMCQ.length ? 'tests' : 'test');
      return title.join(' ');
    }

    openNotification = (type, title, message, duration = undefined) => {
      notification[type]({
        message: title,
        description: message,
        placement: 'topRight',
        duration
      });
    }

    startWorkExp = (challenge_id) => {
      const { maintenance_mcq_acc_apt = false } = this.props.LDFlags;
      if (isMobile) {
        return this.openMobilePopup();
      }
      if (maintenance_mcq_acc_apt) {
        this.openNotification(
          'info', 
          'Maintenance', 
          'We apologize for the inconvenience. This feature is currently undergoing maintenance to provide you with an even better experience. Please check back soon.', 
          20
        );
        return;
      }

      this.setState({ ...this.state, asaModalVisible: false }, () => {
        gtmTag('tookMCQ', { MCQstart: 'True' });
        this.proceedMCQ(challenge_id);
      });
    };

    showWorkExpConfirmation = () => {
      this.setState({ ...this.state, asaModalVisible: true });
    }

    closeAsaModal = () => {
      this.setState({ ...this.state, asaModalVisible: false });
    }

    closeStartMCQModal = () => {
      this.setState({ ...this.state, activeItem: null });
    }

    proceedMCQ = (challenge_id, item = null) => {
      const { store } = this.props;
      const { use_mcq_engine, use_vetting_engine_redirection, maintenance_mcq_acc_apt = false, use_mcq_proctoring, use_onboarding_improved_ui_ux_multi_variant } = this.props.LDFlags || {};

      if (maintenance_mcq_acc_apt) {
        this.openNotification(
          'info', 
          'Maintenance', 
          'We apologize for the inconvenience. This feature is currently undergoing maintenance to provide you with an even better experience. Please check back soon.', 
          20
        );
        return;
      }

      if (use_mcq_proctoring) {
        const user = jwt.decode(token);
        turingLogger
          .log({
            eventName: 'MCQ_PROCTORING_CONSENT',
            logData: {
              challengeId: challenge_id,
              userId: user && user.uid,
              consentStatus: 'ALLOW',
              timestamp: new Date(),
            },
          })
          .catch((e) =>
            console.log('error logging MCQ_PROCTORING_CONSENT', e)
          );
      }

      if (item && item.isTechLeadMCQ) {
        localStorage.setItem('TECHLEAD_MCQ_TAKEN', 'true');
        this.onTechLeadModelCloseClick();
      }
      let body = {
        challenge_id: challenge_id
      };
      try {
        const previousData = JSON.parse(localStorage.getItem("previousDevData") || "{}") || undefined;
        const currentTab = previousData.activeTab;
        const itemTab = item && item.stackDemandGroups && item.stackDemandGroups[0] ? `${item.stackDemandGroups[0].stack_demand_id}:1` : '';
        const activeTab = itemTab ? itemTab : currentTab;
        changePreviousDevData({
          ...previousData,
          devStatus: store.home.devStatus,
          practiceMcq: store.tests.practiceMcq || null,
          firstTestPassed: store.home.extraPassedInfo.passed1stMCQ,
          current_challenge_id: challenge_id,
          workExpCompleted: store.home.workExpCompleted,
          firstTechStackPassed: COMPARE_STATUS(store.home.devStatus, STATUS.PASSED_TECH_STACK) > 0,
          turingProfileCompleted: store.tests.turingProfileCompleted,
          mcqInfo: item,
          activeTab,
        });
      } catch (e) {
        pushLog2DV2LogServer.error('TESTS', 'PROCEED_MCQ_PREV_DEV_DATA_ERROR', {}, {}, e.message);
      }
      pushLog2DV2LogServer.info('TESTS', 'PROCEED_MCQ', {}, { challengeId: challenge_id }, null);

      if (use_mcq_engine === true || use_mcq_engine === 'ON') {
        if (use_vetting_engine_redirection) {
          return redirectToVettingEngineV2(challenge_id);
        } else {
          return redirectMCQToVettingEngine(challenge_id);
        }
      }

      axios.post(`${ApiConstant.BASE_URL}check-valid/`, body).then(response => {
        const data = response.data;
        if (data.success) {
          pushLog2DV2LogServer.info('TESTS', 'PROCEED_MCQ_SUCCESS', {}, { challengeId: challenge_id }, null);
          body = {
            action: 'ADD_TRACK_CHALLENGE',
            challenge_id: challenge_id
          };

          /* NEW GTM TAG REQUEST */
          gtmTag('tookMCQ', { challenge_id, challenge_name: item ? item.challenge_name : null });

          axios.post(`${ApiConstant.BASE_URL}challenge/`, body)
            .then(response => {
              const data = response.data;
              if (data.success) {
                localStorage.setItem('k', data.k); /* Misleading name k on purpose */
                localStorage.setItem('v', data.v); /* Misleading name k on purpose */
                localStorage.removeItem('chromeTypeFix'); /* CHROME navigation.type ALWASY 1 EVENT NOT REFRESH */
                localStorage.removeItem('vetsmith_challenge_id');
                const action = takeChallengeAction(challenge_id);
                this.props.dispatch(action);
                if (window.location.pathname.includes('takechallenge')) {
                  window.location.reload();
                } else {
                  this.props.history.push('/dashboard/takechallenge');
                }
              } else {
                this.openNotification('error', 'Cannot start challenge', data.errorMessage ? data.errorMessage : 'Please try again later.');
                /* 13th. OCT - SEGMENT.IO */
                /* 2. Error_Algo_Proceed */
                if (item) {
                  if (this.state.timeleft > 0) {
                    // [LOGGING] ERROR_CONTINUE
                    pushLog2DV2LogServer.error('SEGMENTIO', 'ERROR_CONTINUE', {}, {
                      challenge_id: this.challenge_id,
                      challenge_name: this.challenge_name,
                      step: 0,
                      correctAnswer: 0
                    }, {
                      message: 'Cannot continue challenge'
                    });
                  } else {
                    // [LOGGING] ERROR_PROCEED
                    pushLog2DV2LogServer.error('SEGMENTIO', 'ERROR_PROCEED', {}, {
                      challenge_id: this.challenge_id,
                      challenge_name: this.challenge_name,
                      step: 0,
                      correctAnswer: 0
                    }, {
                      message: 'Cannot add track challenge'
                    });
                  }
                }
              }
            });
        } else if (data.failingConds && data.failingConds.length) {
          pushLog2DV2LogServer.warn('TESTS', 'PROCEED_MCQ_ERROR', {}, { failingConds: data.failingConds }, { message: 'Complete the following to proceed' });
          this.openNotification(
            'warning',
            'Complete the following to proceed:',
            helpers.conditionNameToRoute(data.failingConds, null),
            0
          );
          /* 13th. OCT - SEGMENT.IO */
          /* 2. Error_Algo_Proceed */
          if (item) {
            if (item.timeleft > 0) {
              // [LOGGING] ERROR_CONTINUE
              pushLog2DV2LogServer.error('SEGMENTIO', 'ERROR_CONTINUE', {}, {
                challenge_id: item.challenge_id,
                challenge_name: item.challenge_name,
                step: 0,
                correctAnswer: 0
              }, {
                message: 'User didnot completed pre-defined condition(s)'
              });
            } else {
              // [LOGGING] ERROR_PROCEED
              pushLog2DV2LogServer.error('SEGMENTIO', 'ERROR_PROCEED', {}, {
                challenge_id: item.challenge_id,
                challenge_name: item.challenge_name,
                step: 0,
                correctAnswer: 0
              }, {
                message: 'User didnot completed pre-defined condition(s)'
              });
            }
          }
        }
      });
    }

    editSkills = () => {
      this.setState({ editSkillsVisible: true });
    }

    /**
     * The initMCQItemAB should be removed after `mcq_use_apiv1` has been rolled out to 100% users and all its calls should be replaced
     * with initMCQItemV1()
     */
    initMCQItemAB = item => {
      return this.initMCQItemV2(item);
    };

    /**
     * Delete this method when `mcq_use_apiv1` has been rolled out to 100% of the users
     * @param {*} item The MCQ item the needs to be initialized
     * @returns Initialized MCQ item
     */
    initMCQItem = (item) => {
      const { history, store } = this.props;
      const workExpCompleted = store.home.workExpCompleted;
      const acc_anytime = this.getData('acc_anytime', false);
      item.isTechLeadMCQ = Array.isArray(item.stackDemandGroups) && item.stackDemandGroups.map(elm => +elm.stack_demand_id).includes(+getEnv("REACT_APP_TECHLEAD_STACK_ID"));
      item.start = (args = null) => {
        const { maintenance_mcq_acc_apt = false } = this.props.LDFlags || {};
        /**
         * Show a banner when the MCQ feature is under maintenance and we don't want users to start MCQs.
         * This flag is used for disabling ACC and APT as well.
         */
        if(maintenance_mcq_acc_apt){
          this.openNotification(
                  'info', 
                  'Maintenance', 
                  'We apologize for the inconvenience. This feature is currently undergoing maintenance to provide you with an even better experience. Please check back soon.', 
                  20
          );
          return;
        }

        if (item.passed === 1) {
          return;
        }
        try {
          const previousData = JSON.parse(localStorage.getItem("previousDevData") || "{}") || undefined;
          const currentTab = previousData.activeTab;
          const itemTab = item && item.stackDemandGroups && item.stackDemandGroups[0] ? `${item.stackDemandGroups[0].stack_demand_id}:1` : '';
          const activeTab = itemTab ? itemTab : currentTab;
          changePreviousDevData({
            ...previousData,
            devStatus: store.home.devStatus,
            practiceMcq: store.tests.practiceMcq || null,
            firstTestPassed: store.home.extraPassedInfo.passed1stMCQ,
            current_challenge_id: item.challenge_id,
            workExpCompleted: store.home.workExpCompleted,
            firstTechStackPassed: COMPARE_STATUS(store.home.devStatus, STATUS.PASSED_TECH_STACK) > 0,
            turingProfileCompleted: store.tests.turingProfileCompleted,
            mcqInfo: item,
            activeTab,
          });
        } catch (e) {
          pushLog2DV2LogServer.error('TESTS', 'PROCEED_MCQ_PREV_DEV_DATA_ERROR', {}, {}, e.message);
        }
        if (+item.acc_challenge === 1) {
          if (history && history.push) {
            history.push(PageConstant.CODING_CHALLENGE);
          } else window.location(PageConstant.CODING_CHALLENGE);
          pushLog2DV2LogServer.info('TESTS', 'GO_TO_ACC_PAGE', {}, { mcq: item }, null);
        } else {
          if (!workExpCompleted && !acc_anytime) return;
          this.setState({ activeItem: item });
          if (item && item.isTechLeadMCQ) {
            localStorage.setItem('TECHLEAD_MCQ_TAKEN', 'true');
            this.onTechLeadModelCloseClick();
          }
          pushLog2DV2LogServer.info('TESTS', 'CLICK_TO_START_MCQ', {}, { mcq: item }, null);
          if (args && args.stackId) {
            localStorage.setItem('activeStack', args.stackId);
          }
        }
      };
      item.close = () => {
        this.setState({ activeItem: null });
        localStorage.removeItem('activeStack');
        localStorage.removeItem('passStatus');
      };
      item.editSkills = () => {
        if (!workExpCompleted) return;
        this.setState({ editSkillsVisible: true });
        pushLog2DV2LogServer.info('TESTS', 'CLICK_TO_REPLACE_MCQ', {}, { mcq: item }, null);
      };
      // Please make a note that `allMCQSkillsInProjectExperience` has been removed from the new MCQ List API /api/v1/challenge/mcq/
      item.certified = !!(item.submit_time && item.passed === 1 && item.allMCQSkillsInProjectExperience);
      item.isCompleted = false;
      item.CompletedOrTime = null;
      if (item.timeLeft > 0) {
        item.CompletedOrTime = args => (
          <span className="time-left">
            {`${moment
              .duration(item.timeLeft, 'seconds')
              .format('m [min]')} left`}
          </span>
        );
        item.MCQStatusOrTime = args => (
          <span className='turing-ui-v2-mcq-tests-item-time-left-wrap'>
            <span className='turing-ui-v2-mcq-tests-item-time-paused'>
              <PausedIcon />
              Paused
            </span>
            <Tooltip title={<span className='tooltip-message'> {`${moment
              .duration(item.timeLeft, 'seconds')
              .format('m')} min left`}</span>}>
              <span className="turing-ui-v2-mcq-tests-item-time-left">
                <ClockIcon />
                {`${moment
                  .duration(item.timeLeft, 'seconds')
                  .format('m')} m`}
              </span>
            </Tooltip>
          </span>
        );
      } else if (item.passed === 3 && item.timeLeft === 0 && item.submit_time) {
        item.MCQStatusOrTime = args => (
          <Tooltip
            placement="top"
            title={<span className='tooltip-message'>{moment(item.submit_time).format('MMM D YYYY, hh:mmA')}</span>}
          >
            <span className="completed">
              <CheckMarkIcon />
              <span>
                Passed
              </span>
            </span>
          </Tooltip>
        );
      } else if (item.submit_time) {
        const result = item.passed === 1 ? 'Passed' : (item.passed === 2 ? 'Didn\'t pass' : '');
        const ninetyDays = moment(item.submit_time).add(3, 'months');
        const daysDiff = moment(ninetyDays).diff(moment(), 'days');
        const hoursDiff = moment(ninetyDays).diff(moment(), 'hours');
        let timeText = '';
        let timeTip = '';
        let retake = false;
        if (item.passed === 2) {
          if (daysDiff < 1 && daysDiff > -1 && hoursDiff > 0) {
            timeText = `${hoursDiff} hr`;
            timeTip = `You will be able to take this test again in ${hoursDiff}${hoursDiff > 1 ? ' hrs' : ' hr'}.`;
          } else if (daysDiff > -1 && daysDiff < 1 && hoursDiff < 1) {
            timeText = '< 1 hr';
            timeTip = 'You will be able to retake this test again soon.';
          } else if (daysDiff >= 1) {
            timeText = `${daysDiff} d`;
            timeTip = `You will be able to take this test again in ${daysDiff}${daysDiff > 1 ? ' days' : ' day'}.`;
          } else if (daysDiff < 0) {
            retake = true;
          }
        }
        item.MCQStatusOrTime = args => (
          <>
            {item.passed === 1
              ? (
                <Tooltip
                  placement="top"
                  title={<span className='tooltip-message'>{moment(item.submit_time).format('MMM D YYYY, hh:mmA')}</span>}
                >
                  <span className="completed">
                    <CheckMarkIcon />
                    <span>
                      {result}
                    </span>
                  </span>
                </Tooltip>
              )
              : (
                item.passed === 2
                  ? !retake ? (
                    <span className='didntpass-wrap'>
                      <Tooltip
                        placement="top"
                        title={<span className='tooltip-message'>{moment(item.submit_time).format('MMM D YYYY, hh:mmA')}</span>}
                      >
                        <span className="didntpass">
                          <CrossIcon />
                          <span>
                            {result}
                          </span>
                        </span>
                      </Tooltip>
                    </span>
                  ) :
                    <span className="turing-ui-v2-mcq-tests-item-time-estimate">
                      <ClockIcon className="turing-ui-v2-mcq-tests-item-time-clock" /> {`${convertTime(item.challenge_duration)} ${args.estimated ? 'estimated' : ''}`}
                    </span>
                  : null
              )}

          </>
        );
      } else {
        item.MCQStatusOrTime = args => (
          <span className="turing-ui-v2-mcq-tests-item-time-estimate">
            <ClockIcon className="turing-ui-v2-mcq-tests-item-time-clock" /> {`${convertTime(item.challenge_duration)} ${args.estimated ? 'estimated' : ''}`}
          </span>
        );
      }

      item.Action = args => {
        let action = null;
        const acc_anytime = this.getData('acc_anytime', false);
        if (item.submit_time) {
          if (item.passed === 1 || (item.passed === 3 && item.timeLeft === 0 && item.submit_time)) {
            action = <div className="turing-ui-v2-completed">Completed</div>;
          }
          if (item.passed === 2) {
            const ninetyDays = moment(item.submit_time).add(3, 'months');
            const daysDiff = moment(ninetyDays).diff(moment(), 'days');
            let retake = daysDiff < 0;
            let retakeMessage = `What can I do now?`;
            let retakeToolTipMsg = `You will be able to take this test again in ${daysDiff} ${daysDiff > 1 ? 'days' : 'day'}.`;

            if (item.isTopMCQ) {
              if (item.isFixedMCQ) {
                const role_name = this.getData('user_role_name', '');
                let message = 'This MCQ is required';
                if (role_name) {
                  message += ` for your ${role_name} role`;
                }
                action = <small className="turing-ui-v2-action-small-text">{message}</small>;
              } else {
                action = <Tooltip
                  placement="bottom"
                  title={<span className='tooltip-message'>{retakeToolTipMsg}</span>}
                >
                  <div className="turing-ui-v2-reattempt pointer"
                    onClick={(e) => {
                      this.setShowFailedModal(true, e.target.closest('.turing-ui-v2-mcq-tests-item'), item);
                    }}>
                    {retakeMessage}
                  </div>
                </Tooltip>;
              }
            } else if (retake) {
              action = <Button data-cy={item.challenge_name} disabled={!acc_anytime && !workExpCompleted} className="turing-ui-v2-action-item turing-ui-v2-action-item-start" type="link" onClick={isMobile ? this.openMobilePopup : () => item.start(args)}>Start Quiz</Button>;
            } else {
              action = <Tooltip
                placement="bottom"
                title={<span className='tooltip-message'>{retakeToolTipMsg}</span>}
              >
                <div className="turing-ui-v2-reattempt turing-ui-v2-reattempt-primary pointer"
                  onClick={(e) => {
                    this.setShowFailedModal(true, e.target.closest('.turing-ui-v2-mcq-tests-item'), item);
                  }}>
                  {retakeMessage}
                </div>
              </Tooltip>;
            }
          }
          else if (item.passed !== 1 && item.timeLeft > 0) {
            action = <Button data-cy={item.challenge_name} disabled={!acc_anytime && !workExpCompleted} className="turing-ui-v2-action-item turing-ui-v2-action-item-start" type="link" onClick={isMobile ? this.openMobilePopup : () => item.start(args)}>Continue Quiz</Button>;
          }
        } else {
          action = <Button data-cy={item.challenge_name} disabled={!acc_anytime && !workExpCompleted} className="turing-ui-v2-action-item turing-ui-v2-action-item-start" type="link" onClick={isMobile ? this.openMobilePopup : () => item.start(args)}>Start Quiz</Button>;
        }
        return action;
      };

      item.proceedClicked = () => {
        if (item.timeleft > 0) {
          // [LOGGING] CLICKED_CONTINUE
          pushLog2DV2LogServer.info('SEGMENTIO', 'CLICKED_CONTINUE', {}, {
            challenge_id: item.challenge_id,
            challenge_name: item.challenge_name,
            step: 0,
            correctAnswer: 0,
            message: 'Clicked Continue Test'
          });
          return;
        }

        // [LOGGING] CLICKED_PROCEED
        pushLog2DV2LogServer.info('SEGMENTIO', 'CLICKED_PROCEED', {}, {
          challenge_id: item.challenge_id,
          challenge_name: item.challenge_name,
          step: 0,
          correctAnswer: 0,
          message: 'Clicked Proceed Test'
        });
      };

      item.proceed = async (e) => {
        const { use_mcq_engine, use_vetting_engine_redirection,  maintenance_mcq_acc_apt = false } = this.props.LDFlags || {};
        e.preventDefault();

        if (item.timeleft > 0) {
          // [LOGGING] CONFIRM_CONTINUE
          pushLog2DV2LogServer.info('SEGMENTIO', 'CONFIRM_CONTINUE', {}, {
            challenge_id: item.challenge_id,
            challenge_name: item.challenge_name,
            step: 0,
            correctAnswer: 0,
            message: 'Confirm Continue Test'
          });
        } else {
          // [LOGGING] CONFIRM_PROCEED
          pushLog2DV2LogServer.info('SEGMENTIO', 'CONFIRM_PROCEED', {}, {
            challenge_id: item.challenge_id,
            challenge_name: item.challenge_name,
            step: 0,
            correctAnswer: 0,
            message: 'Confirm Proceed Test'
          });
        }

        if (use_mcq_engine === true || use_mcq_engine === 'ON') {

          if(maintenance_mcq_acc_apt){
            this.openNotification(
                    'info', 
                    'Maintenance', 
                    'We apologize for the inconvenience. This feature is currently undergoing maintenance to provide you with an even better experience. Please check back soon.', 
                    20
            );
            return;
          }

          if(use_vetting_engine_redirection) {
            try {
              await redirectToVettingEngineV2(item.challenge_id)
            } catch (error) {
              this.openNotification('error', error.response.data.message);
              this.closeStartMCQModal()
            }
          }else {
            redirectMCQToVettingEngine(item.challenge_id)
          }
        } else this.proceedMCQ(item.challenge_id, item);
      };

      return item;
    };

    /**
     * Keep this method when `mcq_use_apiv1` has been rolled out to 100% of the users
     * @param {*} item The MCQ item the needs to be initialized
     * @returns Initialized MCQ item
     */
    initMCQItemV1 = item => {
      const { history, store } = this.props;
      const workExpCompleted = store.home.workExpCompleted;
      const acc_anytime = this.getData('acc_anytime', false);

      item.isTechLeadMCQ =
        Array.isArray(item.stackDemandGroups) &&
        item.stackDemandGroups
          .map(elm => +elm.stack_demand_id)
          .includes(+getEnv('REACT_APP_TECHLEAD_STACK_ID'));

      item.start = (args = null) => {
        const { maintenance_mcq_acc_apt = false } = this.props.LDFlags || {};
        /**
         * Show a banner when the MCQ feature is under maintenance and we don't want users to start MCQs.
         * This flag is used for disabling ACC and APT as well.
         */
        if(maintenance_mcq_acc_apt){
          this.openNotification(
                  'info', 
                  'Maintenance', 
                  'We apologize for the inconvenience. This feature is currently undergoing maintenance to provide you with an even better experience. Please check back soon.', 
                  20
          );
          return;
        }

        if (item.passed) {
          return;
        }
        try {
          const previousData =
            JSON.parse(localStorage.getItem('previousDevData') || '{}') ||
            undefined;
          const currentTab = previousData.activeTab;
          const itemTab =
            item && item.stackDemandGroups && item.stackDemandGroups[0]
              ? `${item.stackDemandGroups[0].stack_demand_id}:1`
              : '';
          const activeTab = itemTab ? itemTab : currentTab;
          changePreviousDevData({
            ...previousData,
            devStatus: store.home.devStatus,
            practiceMcq: store.tests.practiceMcq || null,
            firstTestPassed: store.home.extraPassedInfo.passed1stMCQ,
            current_challenge_id: item.challenge_id,
            workExpCompleted: store.home.workExpCompleted,
            firstTechStackPassed:
              COMPARE_STATUS(store.home.devStatus, STATUS.PASSED_TECH_STACK) >
              0,
            turingProfileCompleted: store.tests.turingProfileCompleted,
            mcqInfo: item,
            activeTab
          });
        } catch (e) {
          pushLog2DV2LogServer.error(
            'TESTS',
            'PROCEED_MCQ_PREV_DEV_DATA_ERROR',
            {},
            {},
            e.message
          );
        }
        if (+item.acc_challenge === 1) {
          if (history && history.push) {
            history.push(PageConstant.CODING_CHALLENGE);
          } else window.location(PageConstant.CODING_CHALLENGE);
          pushLog2DV2LogServer.info(
            'TESTS',
            'GO_TO_ACC_PAGE',
            {},
            { mcq: item },
            null
          );
        } else {
          if (!workExpCompleted && !acc_anytime) return;
          this.setState({ activeItem: item });
          if (item && item.isTechLeadMCQ) {
            localStorage.setItem('TECHLEAD_MCQ_TAKEN', 'true');
            this.onTechLeadModelCloseClick();
          }
          pushLog2DV2LogServer.info(
            'TESTS',
            'CLICK_TO_START_MCQ',
            {},
            { mcq: item },
            null
          );
          if (args && args.stackId) {
            localStorage.setItem('activeStack', args.stackId);
          }
        }
      };
      item.close = () => {
        this.setState({ activeItem: null });
        localStorage.removeItem('activeStack');
        localStorage.removeItem('passStatus');
      };
      item.editSkills = () => {
        if (!workExpCompleted) return;
        this.setState({ editSkillsVisible: true });
        pushLog2DV2LogServer.info(
          'TESTS',
          'CLICK_TO_REPLACE_MCQ',
          {},
          { mcq: item },
          null
        );
      };
      item.isCompleted = false;
      item.CompletedOrTime = null;

      /**
       * Condition to show UI when the MCQ has been attempted but not submitted and is in progress
       */
      if (item.state === TestState.IN_PROGRESS) {
        item.CompletedOrTime = args => (
          <span className='time-left'>
            {`${moment
              .duration(item.timeLeft, 'seconds')
              .format('m [min]')} left`}
          </span>
        );
        item.MCQStatusOrTime = args => (
          <span className='turing-ui-v2-mcq-tests-item-time-left-wrap'>
            <span className='turing-ui-v2-mcq-tests-item-time-paused'>
              <PausedIcon />
              Paused
            </span>
            <Tooltip
              title={
                <span className='tooltip-message'>
                  {' '}
                  {`${moment
                    .duration(item.timeLeft, 'seconds')
                    .format('m')} min left`}
                </span>
              }
            >
              <span className='turing-ui-v2-mcq-tests-item-time-left'>
                <ClockIcon />
                {`${moment.duration(item.timeLeft, 'seconds').format('m')} m`}
              </span>
            </Tooltip>
          </span>
        );

        /**
         * Condition to show UI when the MCQ has been passed by the developer and it has been submitted as well.
         */
      } else if (item.passed && item.state === TestState.COMPLETED) {
        item.MCQStatusOrTime = args => (
          <Tooltip
            placement='top'
            title={
              <span className='tooltip-message'>
                {/* Faizal TODO: There might be a timezone related bug here */}
                {moment(item.submit_time).format('MMM D YYYY, hh:mmA')}
              </span>
            }
          >
            <span className='completed'>
              <CheckMarkIcon />
              <span>Passed</span>
            </span>
          </Tooltip>
        );
        /**
         * Condition to show UI when the MCQ has been failed and submitted by the user .
         */
      } else if (!item.passed && item.state === TestState.COMPLETED) {
        const result = "Didn't pass";
        const ninetyDays = moment(item.submit_time).add(3, 'months');
        const daysDiff = moment(ninetyDays).diff(moment(), 'days');
        const hoursDiff = moment(ninetyDays).diff(moment(), 'hours');
        let timeText = '';
        let timeTip = '';
        let retake = false;

        if (daysDiff < 1 && daysDiff > -1 && hoursDiff > 0) {
          timeText = `${hoursDiff} hr`;
          timeTip = `You will be able to take this test again in ${hoursDiff}${
            hoursDiff > 1 ? ' hrs' : ' hr'
          }.`;
        } else if (daysDiff > -1 && daysDiff < 1 && hoursDiff < 1) {
          timeText = '< 1 hr';
          timeTip = 'You will be able to retake this test again soon.';
        } else if (daysDiff >= 1) {
          timeText = `${daysDiff} d`;
          timeTip = `You will be able to take this test again in ${daysDiff}${
            daysDiff > 1 ? ' days' : ' day'
          }.`;
        } else if (daysDiff < 0) {
          retake = true;
        }

        item.MCQStatusOrTime = args => (
          <>
            {!item.passed ? (
              !retake ? (
                <span className='didntpass-wrap'>
                  <Tooltip
                    placement='top'
                    title={
                      <span className='tooltip-message'>
                        {moment(item.submit_time).format('MMM D YYYY, hh:mmA')}
                      </span>
                    }
                  >
                    <span className='didntpass'>
                      <CrossIcon />
                      <span>{result}</span>
                    </span>
                  </Tooltip>
                </span>
              ) : (
                <span className='turing-ui-v2-mcq-tests-item-time-estimate'>
                  <ClockIcon className='turing-ui-v2-mcq-tests-item-time-clock' />{' '}
                  {`${convertTime(item.challenge_duration)} ${
                    args.estimated ? 'estimated' : ''
                  }`}
                </span>
              )
            ) : null}
          </>
        );
        /**
         * Condition to show UI when the MCQ is yet to be attempted by the developer
         */
      } else if (item.state === TestState.TODO) {
        item.MCQStatusOrTime = args => (
          <span className='turing-ui-v2-mcq-tests-item-time-estimate'>
            <ClockIcon className='turing-ui-v2-mcq-tests-item-time-clock' />{' '}
            {`${convertTime(item.challenge_duration)} ${
              args.estimated ? 'estimated' : ''
            }`}
          </span>
        );
      }

      item.Action = args => {
        let action = null;
        const acc_anytime = this.getData('acc_anytime', false);

        if (item.passed && item.state === TestState.COMPLETED) {
          action = <div className='turing-ui-v2-completed'>Completed</div>;
        }
        if (!item.passed && item.state === TestState.COMPLETED) {
          const ninetyDays = moment(item.submit_time).add(3, 'months');
          const daysDiff = moment(ninetyDays).diff(moment(), 'days');
          let retake = daysDiff < 0;
          let retakeMessage = `What can I do now?`;
          let retakeToolTipMsg = `You will be able to take this test again in ${daysDiff} ${
            daysDiff > 1 ? 'days' : 'day'
          }.`;

          if (item.isTopMCQ) {
            if (item.isFixedMCQ) {
              const role_name = this.getData('user_role_name', '');
              let message = 'This MCQ is required';
              if (role_name) {
                message += ` for your ${role_name} role`;
              }
              action = (
                <small className='turing-ui-v2-action-small-text'>
                  {message}
                </small>
              );
            } else {
              action = (
                <Tooltip
                  placement='bottom'
                  title={
                    <span className='tooltip-message'>{retakeToolTipMsg}</span>
                  }
                >
                  <div
                    className='turing-ui-v2-reattempt pointer'
                    onClick={e => {
                      this.setShowFailedModal(
                        true,
                        e.target.closest('.turing-ui-v2-mcq-tests-item'),
                        item
                      );
                    }}
                  >
                    {retakeMessage}
                  </div>
                </Tooltip>
              );
            }
          } else if (retake) {
            action = (
              <Button
                data-cy={item.challenge_name}
                disabled={!acc_anytime && !workExpCompleted}
                className='turing-ui-v2-action-item turing-ui-v2-action-item-start'
                type='link'
                onClick={isMobile ? this.openMobilePopup : () => item.start(args)}
              >
                Start Quiz
              </Button>
            );
          } else {
            action = (
              <Tooltip
                placement='bottom'
                title={
                  <span className='tooltip-message'>{retakeToolTipMsg}</span>
                }
              >
                <div
                  className='turing-ui-v2-reattempt turing-ui-v2-reattempt-primary pointer'
                  onClick={e => {
                    this.setShowFailedModal(
                      true,
                      e.target.closest('.turing-ui-v2-mcq-tests-item'),
                      item
                    );
                  }}
                >
                  {retakeMessage}
                </div>
              </Tooltip>
            );
          }
        } else if (item.state === TestState.IN_PROGRESS) {
          action = (
            <Button
              data-cy={item.challenge_name}
              disabled={!acc_anytime && !workExpCompleted}
              className='turing-ui-v2-action-item turing-ui-v2-action-item-start'
              type='link'
              onClick={() => item.start(args)}
            >
              Continue Quiz
            </Button>
          );
        } else if (item.state === TestState.TODO) {
          action = (
            <Button
              data-cy={item.challenge_name}
              disabled={!acc_anytime && !workExpCompleted}
              className='turing-ui-v2-action-item turing-ui-v2-action-item-start'
              type='link'
              onClick={isMobile ? this.openMobilePopup : () => item.start(args)}
            >
              Start Quiz
            </Button>
          );
        }
        return action;
      };

      item.proceedClicked = () => {
        if (item.timeleft > 0) {
          // [LOGGING] CLICKED_CONTINUE
          pushLog2DV2LogServer.info(
            'SEGMENTIO',
            'CLICKED_CONTINUE',
            {},
            {
              challenge_id: item.challenge_id,
              challenge_name: item.challenge_name,
              step: 0,
              correctAnswer: 0,
              message: 'Clicked Continue Test'
            }
          );
          return;
        }

        // [LOGGING] CLICKED_PROCEED
        pushLog2DV2LogServer.info(
          'SEGMENTIO',
          'CLICKED_PROCEED',
          {},
          {
            challenge_id: item.challenge_id,
            challenge_name: item.challenge_name,
            step: 0,
            correctAnswer: 0,
            message: 'Clicked Proceed Test'
          }
        );
      };

      item.proceed = async e => {
        const { use_mcq_engine, use_vetting_engine_redirection } =
          this.props.LDFlags || {};
        e.preventDefault();

        if (item.timeleft > 0) {
          // [LOGGING] CONFIRM_CONTINUE
          pushLog2DV2LogServer.info(
            'SEGMENTIO',
            'CONFIRM_CONTINUE',
            {},
            {
              challenge_id: item.challenge_id,
              challenge_name: item.challenge_name,
              step: 0,
              correctAnswer: 0,
              message: 'Confirm Continue Test'
            }
          );
        } else {
          // [LOGGING] CONFIRM_PROCEED
          pushLog2DV2LogServer.info(
            'SEGMENTIO',
            'CONFIRM_PROCEED',
            {},
            {
              challenge_id: item.challenge_id,
              challenge_name: item.challenge_name,
              step: 0,
              correctAnswer: 0,
              message: 'Confirm Proceed Test'
            }
          );
        }

        if (use_mcq_engine === true || use_mcq_engine === 'ON') {
          if (use_vetting_engine_redirection) {
            try {
              await redirectToVettingEngineV2(item.challenge_id);
            } catch (error) {
              this.openNotification('error', error.response.data.message);
              this.closeStartMCQModal();
            }
          } else {
            redirectMCQToVettingEngine(item.challenge_id);
          }
        } else this.proceedMCQ(item.challenge_id, item);
      };

      return item;
    };

    initMCQItemV2 = item => {
      const { history, store, LDFlags } = this.props;
      const { home } = store;
      const {  use_role_based_mcq_uiux, enable_language_quiz } = LDFlags;
      const workExpCompleted = store.home.workExpCompleted;
      const devStatusAllow = COMPARE_STATUS(home.devStatus, STATUS.SCHEDULING_TECH_INTERVIEW) >= 0 || home.devStatus === STATUS.FAILED || home.devStatus === STATUS.FAILED_ACC;
      const disableTestStart = !use_role_based_mcq_uiux && !workExpCompleted && !devStatusAllow;
      item.start = (args = null) => {
        const { maintenance_mcq_acc_apt = false } = this.props.LDFlags || {};
        /**
         * Show a banner when the MCQ feature is under maintenance and we don't want users to start MCQs.
         * This flag is used for disabling ACC and APT as well.
         */
        if(maintenance_mcq_acc_apt){
          this.openNotification(
                  'info', 
                  'Maintenance', 
                  'We apologize for the inconvenience. This feature is currently undergoing maintenance to provide you with an even better experience. Please check back soon.', 
                  20
          );
          return;
        }

        if (item.passed) {
          return;
        }
        try {
          const previousData =
            JSON.parse(localStorage.getItem('previousDevData') || '{}') ||
            undefined;
          const currentTab = previousData.activeTab;
          const itemTab =
            item && item.stackDemandGroups && item.stackDemandGroups[0]
              ? `${item.stackDemandGroups[0].stack_demand_id}:1`
              : '';
          const activeTab = itemTab ? itemTab : currentTab;
          changePreviousDevData({
            ...previousData,
            devStatus: store.home.devStatus,
            practiceMcq: store.tests.practiceMcq || null,
            firstTestPassed: store.home.extraPassedInfo.passed1stMCQ,
            current_challenge_id: item.challenge_id,
            workExpCompleted: store.home.workExpCompleted,
            firstTechStackPassed:
              COMPARE_STATUS(store.home.devStatus, STATUS.PASSED_TECH_STACK) >
              0,
            turingProfileCompleted: store.tests.turingProfileCompleted,
            mcqInfo: item,
            activeTab
          });
        } catch (e) {
          pushLog2DV2LogServer.error(
            'TESTS',
            'PROCEED_MCQ_PREV_DEV_DATA_ERROR',
            {},
            {},
            e.message
          );
        }
        if (+item.acc_challenge === 1) {
          if (history && history.push) {
            history.push(PageConstant.CODING_CHALLENGE);
          } else window.location(PageConstant.CODING_CHALLENGE);
          pushLog2DV2LogServer.info(
            'TESTS',
            'GO_TO_ACC_PAGE',
            {},
            { mcq: item },
            null
          );
        } else {
          if (disableTestStart) return;
          this.setState({ activeItem: item });
          pushLog2DV2LogServer.info(
            'TESTS',
            'CLICK_TO_START_MCQ',
            {},
            { mcq: item },
            null
          );
        }
      };
      item.close = () => {
        this.setState({ activeItem: null });
        localStorage.removeItem('passStatus');
      };
      item.editSkills = () => {
        if (disableTestStart) return;
        this.setState({ editSkillsVisible: true });
        pushLog2DV2LogServer.info(
          'TESTS',
          'CLICK_TO_REPLACE_MCQ',
          {},
          { mcq: item },
          null
        );
      };
      item.isCompleted = false;
      item.CompletedOrTime = null;

      /**
       * Condition to show UI when the MCQ has been attempted but not submitted and is in progress
       */
      if (item.state === TestState.IN_PROGRESS) {
        item.CompletedOrTime = args => (
          <span className='time-left'>
            {`${moment
              .duration(item.timeLeft, 'seconds')
              .format('m [min]')} left`}
          </span>
        );
        item.MCQStatusOrTime = args => (
          <span className='turing-ui-v2-mcq-tests-item-time-left-wrap'>
            <span className='turing-ui-v2-mcq-tests-item-time-paused'>
              <PausedIcon />
              Paused
            </span>
            <Tooltip
              title={
                <span className='tooltip-message'>
                  {' '}
                  {`${moment
                    .duration(item.timeLeft, 'seconds')
                    .format('m')} min left`}
                </span>
              }
            >
              <span className='turing-ui-v2-mcq-tests-item-time-left'>
                <ClockIcon />
                {`${moment.duration(item.timeLeft, 'seconds').format('m')} m`}
              </span>
            </Tooltip>
          </span>
        );

        /**
         * Condition to show UI when the MCQ has been passed by the developer and it has been submitted as well.
         */
      } else if (item.passed && item.state === TestState.COMPLETED) {
        item.MCQStatusOrTime = args => (
          <Tooltip
            placement='top'
            title={
              <span className='tooltip-message'>
                {/* Faizal TODO: There might be a timezone related bug here */}
                {moment(item.submit_time).format('MMM D YYYY, hh:mmA')}
              </span>
            }
          >
            <span className='completed'>
              <CheckMarkIcon />
              <span>Passed</span>
            </span>
          </Tooltip>
        );
        /**
         * Condition to show UI when the MCQ has been failed and submitted by the user .
         */
      } else if (!item.passed && item.state === TestState.COMPLETED) {
        const result = "Didn't pass";
        const ninetyDays = moment(item.submit_time).add(3, 'months');
        const daysDiff = moment(ninetyDays).diff(moment(), 'days');
        const hoursDiff = moment(ninetyDays).diff(moment(), 'hours');
        let timeText = '';
        let timeTip = '';
        let retake = false;

        if (daysDiff < 1 && daysDiff > -1 && hoursDiff > 0) {
          timeText = `${hoursDiff} hr`;
          timeTip = `You will be able to take this test again in ${hoursDiff}${
            hoursDiff > 1 ? ' hrs' : ' hr'
          }.`;
        } else if (daysDiff > -1 && daysDiff < 1 && hoursDiff < 1) {
          timeText = '< 1 hr';
          timeTip = 'You will be able to retake this test again soon.';
        } else if (daysDiff >= 1) {
          timeText = `${daysDiff} d`;
          timeTip = `You will be able to take this test again in ${daysDiff}${
            daysDiff > 1 ? ' days' : ' day'
          }.`;
        } else if (daysDiff < 0) {
          retake = true;
        }

        item.MCQStatusOrTime = args => (
          <>
            {!item.passed ? (
              !retake ? (
                <span className='didntpass-wrap'>
                  <Tooltip
                    placement='top'
                    title={
                      <span className='tooltip-message'>
                        {moment(item.submit_time).format('MMM D YYYY, hh:mmA')}
                      </span>
                    }
                  >
                    <span className='didntpass'>
                      <CrossIcon />
                      <span>{result}</span>
                    </span>
                  </Tooltip>
                </span>
              ) : (
                <span className='turing-ui-v2-mcq-tests-item-time-estimate'>
                  <ClockIcon className='turing-ui-v2-mcq-tests-item-time-clock' />{' '}
                  {`${convertTime(item.challenge_duration)} ${
                    args.estimated ? 'estimated' : ''
                  }`}
                </span>
              )
            ) : null}
          </>
        );
        /**
         * Condition to show UI when the MCQ is yet to be attempted by the developer
         */
      } else if (item.state === TestState.TODO) {
        item.MCQStatusOrTime = args => (
          <span className='turing-ui-v2-mcq-tests-item-time-estimate'>
            <ClockIcon className='turing-ui-v2-mcq-tests-item-time-clock' />{' '}
            {`${convertTime(item.challenge_duration)} ${
              args.estimated ? 'estimated' : ''
            }`}
          </span>
        );
      }

      item.Action = args => {
        let action = null;
        if (enable_language_quiz && !item.challenge_id && item.language_name) {
          action = (
            <Button
              data-cy={item.language_name}
              disabled
            >
              Coming soon
            </Button>
          );
        }
        if (item.passed && item.state === TestState.COMPLETED) {
          action = <div className='turing-ui-v2-completed'>Completed</div>;
        }
        if (!item.passed && item.state === TestState.COMPLETED) {
          const ninetyDays = moment(item.submit_time).add(3, 'months');
          const daysDiff = moment(ninetyDays).diff(moment(), 'days');
          let retake = daysDiff < 0;
          let retakeMessage = `What can I do now?`;
          let retakeToolTipMsg = `You will be able to take this test again in ${daysDiff} ${
            daysDiff > 1 ? 'days' : 'day'
          }.`;

          if (item.isTopMCQ) {
            if (item.isFixedMCQ) {
              const role_name = this.getData('user_role_name', '');
              let message = 'This MCQ is required';
              if (role_name) {
                message += ` for your ${role_name} role`;
              }
              action = (
                <small className='turing-ui-v2-action-small-text'>
                  {message}
                </small>
              );
            } else {
              action = (
                <Tooltip
                  placement='bottom'
                  title={
                    <span className='tooltip-message'>{retakeToolTipMsg}</span>
                  }
                >
                  <div
                    className='turing-ui-v2-reattempt pointer'
                    onClick={e => {
                      this.setShowFailedModal(
                        true,
                        e.target.closest('.turing-ui-v2-mcq-tests-item'),
                        item
                      );
                    }}
                  >
                    {retakeMessage}
                  </div>
                </Tooltip>
              );
            }
          } else if (retake) {
            action = (
              <Button
                data-cy={item.challenge_name}
                disabled={disableTestStart}
                className='turing-ui-v2-action-item turing-ui-v2-action-item-start'
                type='link'
                onClick={isMobile ? this.openMobilePopup : () => item.start(args)}
              >
                Start Quiz
              </Button>
            );
          } else {
            action = (
              <Tooltip
                placement='bottom'
                title={
                  <span className='tooltip-message'>{retakeToolTipMsg}</span>
                }
              >
                <div
                  className='turing-ui-v2-reattempt turing-ui-v2-reattempt-primary pointer'
                  onClick={e => {
                    this.setShowFailedModal(
                      true,
                      e.target.closest('.turing-ui-v2-mcq-tests-item'),
                      item
                    );
                  }}
                >
                  {retakeMessage}
                </div>
              </Tooltip>
            );
          }
        } else if (item.state === TestState.IN_PROGRESS) {
          action = (
            <Button
              data-cy={item.challenge_name}
              disabled={disableTestStart}
              className='turing-ui-v2-action-item turing-ui-v2-action-item-start'
              type='link'
              onClick={() => item.start(args)}
            >
              Continue Quiz
            </Button>
          );
        } else if (item.state === TestState.TODO) {
          action = (
            <Button
              data-cy={item.challenge_name}
              disabled={disableTestStart}
              className='turing-ui-v2-action-item turing-ui-v2-action-item-start'
              type='link'
              onClick={isMobile ? this.openMobilePopup : () => item.start(args)}
            >
              Start Quiz
            </Button>
          );
        }
        return action;
      };

      item.proceedClicked = () => {
        if (item.timeleft > 0) {
          // [LOGGING] CLICKED_CONTINUE
          pushLog2DV2LogServer.info(
            'SEGMENTIO',
            'CLICKED_CONTINUE',
            {},
            {
              challenge_id: item.challenge_id,
              challenge_name: item.challenge_name,
              step: 0,
              correctAnswer: 0,
              message: 'Clicked Continue Test'
            }
          );
          return;
        }

        // [LOGGING] CLICKED_PROCEED
        pushLog2DV2LogServer.info(
          'SEGMENTIO',
          'CLICKED_PROCEED',
          {},
          {
            challenge_id: item.challenge_id,
            challenge_name: item.challenge_name,
            step: 0,
            correctAnswer: 0,
            message: 'Clicked Proceed Test'
          }
        );
      };

      item.proceed = async e => {
        const { use_mcq_engine, use_vetting_engine_redirection, enable_language_quiz } =
          this.props.LDFlags || {};
        e.preventDefault();

        if (item.timeleft > 0) {
          // [LOGGING] CONFIRM_CONTINUE
          pushLog2DV2LogServer.info(
            'SEGMENTIO',
            'CONFIRM_CONTINUE',
            {},
            {
              challenge_id: item.challenge_id,
              challenge_name: item.challenge_name,
              step: 0,
              correctAnswer: 0,
              message: 'Confirm Continue Test'
            }
          );
        } else {
          // [LOGGING] CONFIRM_PROCEED
          pushLog2DV2LogServer.info(
            'SEGMENTIO',
            'CONFIRM_PROCEED',
            {},
            {
              challenge_id: item.challenge_id,
              challenge_name: item.challenge_name,
              step: 0,
              correctAnswer: 0,
              message: 'Confirm Proceed Test'
            }
          );
        }
        if (enable_language_quiz && item.is_ai_challenge) {
          const user = jwt.decode(token);
          pushLog2DV2LogServer.info(
            'TESTS',
            'START_LANGUAGE_QUIZ',
            {}, { 
              challenge_id: item?.challenge_id, 
              challenge_name: item?.challenge_name, 
              user_id: user?.uid
            }, null);
          await redirectAiToVettingEngine(item.challenge_id, false, window.location.origin + PageConstant.MCQ_LIST);
          return;
        }
        if (use_mcq_engine === true || use_mcq_engine === 'ON') {
          if (use_vetting_engine_redirection) {
            try {
              await redirectToVettingEngineV2(item.challenge_id);
            } catch (error) {
              this.openNotification('error', error.response.data.message);
              this.closeStartMCQModal();
            }
          } else {
            redirectMCQToVettingEngine(item.challenge_id);
          }
        } else this.proceedMCQ(item.challenge_id, item);
      };

      return item;
    };

    closeTakeNextMCQModal = () => {
      if (this.state.takeNextMCQModalVisible && this.state.takeNextMCQModalVisible.callback) {
        const { callback } = this.state.takeNextMCQModalVisible;
        if (typeof callback === 'function') {
          callback();
        }
      }
      this.setState({ takeNextMCQModalVisible: false });
    }

    initTopMCQItem = item => {
      item.isTopMCQ = true;
      return item;
    }

    refreshProgressBar = () => {
      this.setState({ refreshProgressBar: true });
      setTimeout(() => {
        this.setState({ refreshProgressBar: false });
      }, 2000);
    }

    onSkillsModelCloseClick = async () => {
      const { updateSidebar } = this.props;
      this.setState({ editSkillsVisible: false });
      delay(() => {
        if (updateSidebar) updateSidebar();
        this.refreshProgressBar();
        this.loadMCQData();
      }, 100);
    }

    onTechLeadModelCloseClick = () => {
      const showTechLeadOneTestLeftModal = this.getData('showTechLeadOneTestLeftModal', false);
      if (showTechLeadOneTestLeftModal) {
        this.props.dispatch({ type: TestsActions.HIDE_TECHLEAD_ONE_TEST_LEFT_MODAL });
      } else {
        this.props.dispatch({ type: TestsActions.HIDE_TECHLEAD_MODAL });
      }
    }

    onTechLeadNextStackModelCloseClick = () => {
      this.props.dispatch({ type: TestsActions.HIDE_TECHLEAD_NEXTSTACK_MODEL });
    }

    /* Done = Cancel
    onSkillModalCancel = () => {
      const { updateSidebar } = this.props;
      this.setState({ editSkillsVisible: false });
      if (updateSidebar) updateSidebar();
    } */

    setActiveChallenge = (challenge_id) => {
      let allMCQList = this.getData('allChallenges', []).map(this.initMCQItemAB);
      const acc_anytime = this.getData('acc_anytime', false);
      if (acc_anytime) {
        const MCQList = this.getData('challenges', []).filter((item) => item.acc_anytime).map(this.initMCQItemAB);
        allMCQList = allMCQList.concat(MCQList);
      }
      if (allMCQList.length === 0) { return; }
      const mcqItem = allMCQList.find(element => element.challenge_id.toString() === challenge_id);
      if (mcqItem) {
        this.setState({ activeItem: this.initMCQItemAB(mcqItem) });
      }
    }

    showNextMCQ = () => {
      const MCQList = this.getData('challenges', []).map(this.initMCQItemAB).map(this.initTopMCQItem);
      const activeStack = localStorage.getItem('activeStack');
      const passStatus = localStorage.getItem('passStatus');
      if (activeStack && passStatus) {
        let nextActiveMCQ = null;
        let totalStackTest = 0;
        const passedItem = JSON.parse(passStatus);
        // Check available MCQ in the previous MCQ stack
        let nextMCQ = MCQList.filter(mcq => (mcq.stackDemandGroups.map(item => +item.stack_demand_id).includes(+activeStack) &&
          !mcq.submit_time && +mcq.challenge_id !== +passedItem.passed_challenge_id)).sort((a, b) => b.challenge_name - a.challenge_name);
        if (Array.isArray(nextMCQ) && nextMCQ.length) {
          nextActiveMCQ = nextMCQ;
          totalStackTest = nextMCQ.length;
        } else {
          // Check available MCQ from other stacks
          nextMCQ = MCQList.filter(mcq => !mcq.submit_time && +mcq.challenge_id !== +passedItem.passed_challenge_id).sort((a, b) => b.challenge_name - a.challenge_name);
          if (Array.isArray(nextMCQ) && nextMCQ.length) {
            nextActiveMCQ = nextMCQ;
            totalStackTest = nextMCQ.length;
            const newActiveStack = (nextActiveMCQ[0].stackDemandGroups || []).filter(stack => +stack.stack_demand_id !== +activeStack).map(stack => +stack.stack_demand_id);
            const newStackId = newActiveStack[0] || 0;
            localStorage.setItem('activeStack', newStackId);
          }
        }
        if (!Array.isArray(nextMCQ) || !nextMCQ.length) {
          localStorage.removeItem('activeStack');
          localStorage.removeItem('passStatus');
        }
        this.setState({ nextMCQ: nextActiveMCQ, totalStackTest });
      }
    }

    onNextClick = () => {
      const { totalStackTest, activeIndex } = this.state;
      let nextIndex = activeIndex + 1;
      if (activeIndex === totalStackTest - 1) {
        // Reset the index back to the beginning if we are on the last index
        nextIndex = 0;
      }
      this.setState({ activeIndex: nextIndex });
    }

    onSkipMCQ = () => {
      localStorage.removeItem('activeStack');
      localStorage.removeItem('passStatus');
      this.setState({ nextMCQ: null });
    }

    render() {
      const loading = this.getData('loading', false);
      const MCQList = this.getData('challenges', []).map(this.initMCQItemAB).map(this.initTopMCQItem);
      const CoreMCQList = this.getData('core_challenges', []).map(this.initMCQItemAB).map(this.initTopMCQItem);
      const LanguageMCQList = this.getData('developer_language_challenges', []).map(this.initMCQItemV2).map(this.initTopMCQItem);
      const stackDemands = this.getData('stackDemands', []);
      const allMCQList = this.getData('allChallenges', []).map(this.initMCQItemAB);
      const workExpLoading = this.getData('workExpLoading', false);
      const workExpCompleted = this.props.store.home && this.props.store.home.workExpCompleted;
      const isProgrammerRole = this.getData('isProgrammerRole', false);
      const practiceMcq = this.getData('practiceMcq', null);
      const workExpBtn = this.getData('workExpBtnText', null);
      const seniority = this.getData('seniority', null);
      const profileStatus = this.getData('profileCompleted', false);
      const turingProfileCompleted = this.getData('turingProfileCompleted', false);
      const tagsMCQFilter = this.getData('tagsMCQFilter', []);
      const acc_anytime = this.getData('acc_anytime', false);
      const skipASA = this.getData('skipASA', false);
      const { activeItem, takeNextMCQModalVisible, editSkillsVisible, refreshProgressBar, nextMCQ, activeIndex, totalStackTest, asaModalVisible } = this.state;
      const activeStack = localStorage.getItem('activeStack');
      const passStatus = localStorage.getItem('passStatus');
      const showTechLeadModal = this.getData('showTechLeadModal', false);
      const showTechLeadOneTestLeftModal = this.getData('showTechLeadOneTestLeftModal', false);
      const showTechLeadNextStackModel = this.getData('showTechLeadNextStackModel', false);
      let techLeadNextStack = this.getData('techLeadNextStack', null);
      let techLeadStack = this.getData('techLeadStack', null);
      const personal_info = this.getData('personal_info', null);
      if (showTechLeadModal && techLeadStack) techLeadStack = this.initMCQItemAB(techLeadStack);
      if (showTechLeadNextStackModel && techLeadNextStack) techLeadNextStack = this.initMCQItemAB(techLeadNextStack);
      const { home } = this.props.store;
      const { devFlowSteps } = home || {};
      const { mcq_use_apiv1, $flagsReady, use_mcq_proctoring, use_onboarding_improved_ui_ux_multi_variant } = this.props.LDFlags || {};
      return (
        <Spin spinning={loading}>
          {$flagsReady && (
          <>
            <Component testsService={this} MCQList={MCQList} allMCQList={allMCQList} stackDemands={stackDemands}
              workExpLoading={workExpLoading}
              CoreMCQList={CoreMCQList}
              workExpCompleted={workExpCompleted}
              isProgrammerRole={isProgrammerRole}
              workExpBtnText={workExpBtn}
              seniority={seniority}
              practiceMcq={practiceMcq}
              refreshProgress={refreshProgressBar}
              profileCompleted={profileStatus}
              turingProfileCompleted={turingProfileCompleted}
              tagsMCQFilter={tagsMCQFilter}
              acc_anytime={acc_anytime}
              skipASA={skipASA}
              LanguageMCQList={LanguageMCQList}
            />
            <StartMCQModal
              activeItem={activeItem}
              loading={loading}
              testsService={this}
              disabledStart={false}
              mcq_use_apiv1={mcq_use_apiv1}
              use_mcq_proctoring={use_mcq_proctoring}
            />
            <StartASAModal
              isOpen={asaModalVisible}
              onClose={this.closeAsaModal}
              onStart={() => this.startWorkExp(+getEnv("REACT_APP_WORK_EXP_MCQ"))}
            />
            <TakeNextMCQModal
              MCQList={MCQList}
              allMCQList={allMCQList}
              loading={loading}
              visible={!!takeNextMCQModalVisible}
              testsService={this}
              mcq_use_apiv1={mcq_use_apiv1}
            />
            <SkillsEditorModal
              visible={editSkillsVisible}
              onCancel={this.onSkillsModelCloseClick}
              onOk={this.onSkillsModelCloseClick}
              use_onboarding_improved_ui_ux_multi_variant={use_onboarding_improved_ui_ux_multi_variant}
            />
            <FailedMCQModal
              visible={this.state.showFailedModal.visible}
              item={this.state.showFailedModal.item}
              onCancel={() => this.setShowFailedModal(false)}
              editSkills={this.editSkills}
              test={this.state.showFailedModal.test}
              use_onboarding_improved_ui_ux_multi_variant={use_onboarding_improved_ui_ux_multi_variant}
            />
            <TechLeadModel
              visible={(showTechLeadModal || showTechLeadOneTestLeftModal) && ((devFlowSteps && devFlowSteps.step_2_enbale_tests) || !devFlowSteps)}
              oneTestLeft={showTechLeadOneTestLeftModal}
              techLeadStack={techLeadStack}
              personalInfo={personal_info}
              onCancel={this.onTechLeadModelCloseClick}
            />
            <TechLeadNextStack
              visible={showTechLeadNextStackModel && ((devFlowSteps && devFlowSteps.step_2_enbale_tests) || !devFlowSteps)}
              techLeadNextStack={techLeadNextStack}
              personalInfo={personal_info}
              onCancel={this.onTechLeadNextStackModelCloseClick}
            />
            <TakeNextMCQV2
              visible={!!(nextMCQ && activeStack && passStatus && !showTechLeadNextStackModel)}
              nextMCQ={nextMCQ ? nextMCQ[activeIndex] : null}
              onSkipMCQ={this.onSkipMCQ}
              totalStackTest={totalStackTest}
              onNextClick={this.onNextClick}
              mcq_use_apiv1={mcq_use_apiv1}
            />
            <ChallengePagePopup
              isOpen={this.state.isMobilePopupOpen}
              onClose={this.closeMobilePopup}
              title='TURING QUIZZES'
              description_heading="Switch to desktop or laptop to continue this quiz"
              description_body="For the best experience and a fair evaluation, Turing Quizzes are only available on desktop or laptop. We can send you an email with a login link, so you can easily pick up where you left off."
            />
          </>)}
        </Spin>
      );
    }
  }

  const mapStateToProps = (store) => ({ store });
  const mapDispatchToProps = (dispatch) => ({ dispatch });

  TestsService.propTypes = {
    store: PropTypes.object,
    dispatch: PropTypes.func,
    history: PropTypes.any,
    updateSidebar: PropTypes.func,
    LDFlags: PropTypes.object
  };

  return connect(mapStateToProps, mapDispatchToProps)(withRouter(withLDFlagsFromBackend(TestsService, [GB_FLAGS.use_mcq_engine, GB_FLAGS.use_vetting_engine_redirection, GB_FLAGS.use_onboarding_improved_ui_ux_multi_variant, GB_FLAGS.mcq_use_apiv1, GB_FLAGS.maintenance_mcq_acc_apt, GB_FLAGS.use_mcq_proctoring, GB_FLAGS.use_onboarding_improved_ui_ux_multi_variant, GB_FLAGS.use_role_based_mcq_uiux, GB_FLAGS.enable_language_quiz])));
}

const gtmTag = (event, mcq) => {
  /* NEW GTM REQUEST */

  const currentQuery = queryString.parse(window.location.search);
  const s_param = currentQuery.s || '';

  const tagManagerArgs = {
    gtmId: getEnv("REACT_APP_GTM_ID"),
    dataLayer: {
      event,
      userEmail: localStorage.getItem('userEmail'),
      s_param,
      tookMCQ: {
        mcq_id: mcq.challenge_id,
        mcq_name: mcq.challenge_name
      }
    }
  };

  TagManager.dataLayer(tagManagerArgs);
};

export { MCQ_GROUPS };
export default withTestsService;
